const SITECORE_MEDIA_RX = /\/(?:-|~)?\/media\//i;
const DOWNLOAD_API_PATH = '/api/download';

function isDownloadProxyUrl(url: string): boolean {
  try {
    const base = process.env.PUBLIC_URL;
    return new URL(url, base).pathname.toLowerCase() === DOWNLOAD_API_PATH;
  } catch {
    return false;
  }
}

export function isDownloadPathname(pathname?: string): boolean {
  if (!pathname) return false;
  if (isCustomProtocol(pathname)) return false;

  let parsedUrl: URL;
  try {
    const base = process.env.PUBLIC_URL;
    parsedUrl = new URL(pathname, base);
  } catch {
    return false;
  }

  const parsedPathname = parsedUrl.pathname.toLowerCase();
  if (parsedPathname === DOWNLOAD_API_PATH) {
    const nestedUrl = parsedUrl.searchParams.get('url');
    return !!nestedUrl && isDownloadPathname(nestedUrl);
  }

  const lowerPath = parsedPathname.toLowerCase();
  if (SITECORE_MEDIA_RX.test(lowerPath)) return true;
  const lastPathSegment = lowerPath.substring(lowerPath.lastIndexOf('/') + 1).replace(/%2e/gi, '.');
  return lastPathSegment.endsWith('.pdf');
}
export function isAsDownload(u?: { pathname?: string; href?: string } | URL | null): boolean {
  if (!u) return false;
  const href = (u as { href?: string }).href || '';
  if (href) {
    return isDownloadPathname(href);
  }
  const directPathname = (u as { pathname?: string }).pathname;
  if (typeof directPathname === 'string') {
    return isDownloadPathname(directPathname);
  }
  try {
    const base = process.env.PUBLIC_URL;
    const { pathname } = new URL(href, base);
    return isDownloadPathname(pathname);
  } catch {
    return false;
  }
}

/**
 * Returns the download url for a given url.  This is needed because the `download` attribute is not supported in the browser for external links.
 * This will proxy the request to the `/api/download` route and return the response body.
 * @param url - The url to get the download url for
 * @returns The download url
 * @example
 * const downloadUrl = getDownloadUrl('https://example.com/file.pdf');
 * console.log(downloadUrl); // '/api/download?url=https%3A%2F%2Fexample.com%2Ffile.pdf'
 */
export function getDownloadUrl(url: string): string {
  if (isCustomProtocol(url)) {
    return url;
  }
  if (isDownloadProxyUrl(url)) {
    return url;
  }
  return `/api/download?url=${encodeURIComponent(url)}`;
}

function isCustomProtocol(url: string): boolean {
  const hrefWithoutHttp = url.replace(/^https?\:\/\//, '');

  // Custom protocols (e.g. tel:, mailto: and other custom ones like whatsapp:) should not have https:// added
  const isCustomProtocol = !!hrefWithoutHttp?.match(/^[a-z][a-z0-9\+\-\.]+\:/i);
  return isCustomProtocol;
}
